import React,{useEffect} from 'react';
import { Route, Routes } from 'react-router-dom';
import { PassProvider } from './hooks/PassContext';
import { OrderProvider } from './hooks/OrderContext';
import RootLayout from './modules/root/RootLayout';
import {Home} from './modules/root/pages/Home';
import { Passes } from './modules/root/components/passes/Passes';
import { Cart } from './modules/root/components/order/Cart';
import { Delivery } from './modules/root/components/order/Delivery'
import { Billing } from './modules/root/components/order/Billing';
import { Review } from './modules/root/components/order/Review';
import { OrderSummary } from './modules/root/components/order/OrderSummary';
import { GeneratePasses } from './modules/root/components/order/GeneratePasses';
import { CspTemporaryPass } from './modules/root/components/order/CspTemporaryPass';
import { useLoader } from './hooks/LoaderContext';
import { setupAxiosInterceptors } from './services/LoaderService';
import { ToastContainer } from 'react-toastify';
import { ProtectedRoute } from './modules/root/components/protectedRoute/ProtectedRoute';
//Admin
import {AdminLayout} from './modules/admin/AdminLayout';
import { AuthProvider } from './hooks/AuthContext';
import {Login} from './modules/admin/components/login/Login';
import { AdminPage } from './modules/admin/components/login/AdminPage';
import { ProtectedAdminRoute } from './modules/admin/components/protectedAdminRoute/ProtectedAdminRoute';
//For Admin Okta COnfiguration
import { Security, LoginCallback} from '@okta/okta-react';
import { oktaAuth } from './config/OktaConfig';
// Define the restoreOriginalUri callback
const restoreOriginalUri = ({ originalUri }) => {
    window.location.replace(originalUri || '/admin/adminPage');
};

const AppRoutes = () => {
    const { setLoading } = useLoader();
    useEffect(() => {
        setupAxiosInterceptors(setLoading); // Set up interceptors to manage loading state
    }, [setLoading]);

    const isCartCreated = !!sessionStorage.getItem('wa_crt_cid');
    return(
        <Security oktaAuth={oktaAuth}  restoreOriginalUri={restoreOriginalUri} >
        <AuthProvider>
        <PassProvider>
        <OrderProvider>
            <ToastContainer/>
            <Routes>
                {/* Root Module Routes */}
                <Route path="/" element={<RootLayout />}>
                    <Route index element={<Home />} />
                    <Route exact path='/shop/:pageSlug' Component={Passes}></Route>
                    <Route exact path='/cart' Component={Cart}></Route>
                    <Route exact path='/delivery' element={
                        <ProtectedRoute hasAccess={isCartCreated}>
                            <Delivery />
                        </ProtectedRoute>
                    }></Route>
                    <Route exact path='/billing' element={
                        <ProtectedRoute hasAccess={isCartCreated}>
                            <Billing />
                        </ProtectedRoute>
                    }></Route>
                    <Route exact path='/review' element={
                        <ProtectedRoute hasAccess={isCartCreated}>
                            <Review/>
                        </ProtectedRoute>
                    }></Route>
                    <Route exact path='/order-summary'element={
                        <ProtectedRoute hasAccess={isCartCreated}>
                            <OrderSummary/>
                        </ProtectedRoute>
                    }></Route>
                    <Route exact path='/orders/generated-passes/:OrderGUID' Component={GeneratePasses}></Route>
                    <Route exact path='/mydiscoverpass/temporary-pass/:passGUID' Component={CspTemporaryPass}></Route>
                </Route>

                {/* Admin Module Routes */}
                <Route path="/admin" element={<AdminLayout />}>
                    <Route index element={<Login />} />
                    <Route path="adminPage" element={<ProtectedAdminRoute> <AdminPage /></ProtectedAdminRoute>
                    }/>
                </Route>

                {/* Add LoginCallback for Okta */}
                <Route path="/login/callback" element={<LoginCallback/>} />
            </Routes>
        </OrderProvider>
    </PassProvider>
    </AuthProvider>
    </Security>
    )
};

export default AppRoutes;